import React from 'react';
import { Flex, Link, Text } from '@chakra-ui/react';
import { TransactionAvatar } from '../TransactionsList/transactionAvatar';
import { TransactionType } from '../TransactionsList/transactionElement';
import { ITransaction } from '../TransactionsList/transactionsList';
import { Network } from '../../providers/Networks/useNetworks';
import { blockchainConfig } from '../../blockchain-config';
import { trimTransactionId } from '../../utils/parser';
import { Color } from 'src/theme/color';

export const transactionScanUri: { [p: number]: (id: string) => string } = {
	[Network.MUMBAI_TESTNET]: (id: string) => `https://mumbai.polygonscan.com/tx/${id}`,
	[Network.POLYGON_MAINNET]: (id: string) => `https://polygonscan.com/tx/${id}`,
};

export const TransactionResult = ({ data }: { data: ITransaction }) => {
	return (
		<Link
			_hover={{ background: 'rgba(0,0,0, .1)', borderRadius: '5px', textDecoration: 'none' }}
			href={transactionScanUri[blockchainConfig.NETWORK_DEFAULT.ID](data.id)}
			target="_blank"
			display="flex"
		>
			<TransactionAvatar
				type={TransactionType.HASH}
				subject={{ address: data.id, icon: '/icons/transaction_transfer.svg' /** @TODO */ }}
			/>
			<Flex
				flexDirection="column"
				gridGap="8px"
				ml="24px"
				justifyContent="center"
			>
				<Text
					fontSize="12px"
					lineHeight="14px"
					letterSpacing="0.07em"
					color={Color.BACKGROUND_TERTIARY}
				>
					{trimTransactionId(data.id)}
				</Text>
			</Flex>
		</Link>
	);
};
